import { getAuthTokenCookieValue } from './get-auth-token-cookie-value';

export function getAccessToken() {
    const cookieValue = getAuthTokenCookieValue();
    if (!cookieValue) {
        return '';
    }
    const authToken = JSON.parse(cookieValue);
    const accessToken = authToken?.['session']?.['accessToken'] || '';
    return accessToken;
}
